export default __webpack_public_path__ + "static/media/pie-chart.b2ff4359.png";